

import { TEXTES_COMPREHENSION, nomDuTexte } from '../components/VueEvalNat/EvalNat/evaluationConfig';
import { classesAvecCopies, niveauDe } from './campagneEvalNat';

export const getColorThemeEvalNat = (EvalNatDetail) => {
    const resultatsParTheme = {
        // Thèmes Maths
        'Espace et Géométrie': [],
        'Nombre et Calculs': [],
        'Grandeurs et mesures': [],
        'Organisation et Gestion de données': [],
        'Automatismes': [],
        'Problèmes': [],
        // Thèmes Français
        'Compréhension Orale': [],
        'Compréhension Écrite': [],
        'Étude de la Langue - Composition': [],
        'Orthographe': [],
        'Lexique': [],
        'Fluence': [],
        'Compétences langagières et linguistiques': [],
    };

    const getColor = (reponse) => {
        switch(reponse.trim()) {
            case 'À besoins':
                return 'rgba(239, 68, 68, 0.95)';
            case 'A besoins':
                return 'rgba(239, 68, 68, 0.95)';
            case 'A besoin':
                return 'rgba(239, 68, 68, 0.95)';
            case 'Fragile':
                return 'rgba(251, 191, 36, 0.95)';
            case 'Satisfaisant':
                return 'rgba(134, 239, 172, 0.95)';
            case 'Très Satisfaisant':
                return 'rgba(34, 139, 34, 0.95)';
            default:
                return 'grey';
        }
    };

    EvalNatDetail?.eleves_reponses?.forEach(eleve => {
        const nomEleve = eleve.nom_eleve;
        const reponsesEleve = eleve.reponses;

        // Maths - on ajoute seulement si la donnée existe
        if (reponsesEleve['NEC']) {
            resultatsParTheme['Nombre et Calculs'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['NEC'])
            });
        }
        if (reponsesEleve['EEG']) {
            resultatsParTheme['Espace et Géométrie'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['EEG'])
            });
        }
        if (reponsesEleve['GEM']) {
            resultatsParTheme['Grandeurs et mesures'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['GEM'])
            });
        }
        if (reponsesEleve['OGD']) {
            resultatsParTheme['Organisation et Gestion de données'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['OGD'])
            });
        }
        if (reponsesEleve['Automatisme']) {
            resultatsParTheme['Automatismes'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['Automatisme'])
            });
        }
        if (reponsesEleve['Probleme']) {
            resultatsParTheme['Problèmes'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['Probleme'])
            });
        }

        // Français
        if (reponsesEleve['ComprehensionOrale']) {
            resultatsParTheme['Compréhension Orale'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['ComprehensionOrale'])
            });
        }
        if (reponsesEleve['TestComprehensionEcrite']) {
            resultatsParTheme['Compréhension Écrite'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['TestComprehensionEcrite'])
            });
        }
        if (reponsesEleve['EtudeLangueComposition']) {
            resultatsParTheme['Étude de la Langue - Composition'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['EtudeLangueComposition'])
            });
        }
        if (reponsesEleve['Orthographe']) {
            resultatsParTheme['Orthographe'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['Orthographe'])
            });
        }
        if (reponsesEleve['TestLexique'] && typeof reponsesEleve['TestLexique'] === 'string') {
            resultatsParTheme['Lexique'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['TestLexique'])
            });
        }
        if (reponsesEleve['Fluence']) {
            resultatsParTheme['Fluence'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['Fluence'])
            });
        }
         if (reponsesEleve['CompetencesLangagieres']) {
            resultatsParTheme['Compétences langagières et linguistiques'].push({
                eleveNom: nomEleve,
                couleur: getColor(reponsesEleve['CompetencesLangagieres'])
            });
        }
    });

    // Nettoyer les thèmes vides
    Object.keys(resultatsParTheme).forEach(key => {
        if (resultatsParTheme[key].length === 0) {
            delete resultatsParTheme[key];
        }
    });

    return resultatsParTheme;
};



/**
 * Parse les réponses EvalNat pour ChoixRenderer.
 * Si r.type === 'element', le contenu est du JSON stringifié → on le parse en objet { type, config }.
 * Sinon on retourne le contenu tel quel (string simple).
 */
export const parseEvalNatChoix = (reponses) =>
  (reponses || []).map(r => {
    if (r.type === 'image' && r.image) {
      return { type: 'image', config: { imageUrl: r.image } };
    }
    if (r.type === 'element' && typeof r.contenu === 'string') {
      try { return JSON.parse(r.contenu); } catch { return r.contenu; }
    }
    return r.contenu;
  });

// Récuperer les classes qui n'ont pas encore eu de résultat d'évaluations nationales.
export const  getClassesWithoutNationalEvaluations = ( etablissement, EvalsNatGroupe, niveau, matiere) => {

    // Créer un tableau pour stocker les classes qui n'ont pas de résultats
    const classesSansResultats = [];
    // Les classes qui ont des résultats : évaluation par classe ou copies d'une campagne (D9), filtrées par
    // matière si elle est donnée ; un bilan ne compte pas (défaut 12).
    const classesAvecResultats = classesAvecCopies(EvalsNatGroupe, { matiere });
    // Identifier les classes sans résultats en comparant avec le Set
    const nomsClasses = etablissement.classes.map(classe => classe.nom);


     // Extraire les noms des classes à partir des classe de l'établissement.
    nomsClasses.forEach((classeName) => {
      if (!classesAvecResultats.has(classeName)) {
        if(classeName[0] === (niveau ? niveau : "6")) {
          classesSansResultats.push(classeName)
        };
      }
    });

    // Retourner la liste des classes sans résultats
    return classesSansResultats;
  }


// ─── Réussite PAR ITEM (éval nationale) ───────────────────────────────────────

// score brut (1 / 0 / "" / absent) → état d'affichage d'un item.
export const etatDepuisScore = (score) => {
  if (score === 1) return 'reussi';
  if (score === '' || score === null || score === undefined) return 'vide';
  return 'rate';
};

// Catégories d'items disponibles selon matière + niveau (1re lettre de classe_nom).
const categoriesEvalNat = (matiere, niveau) => {
  if (matiere === 'maths') {
    const cats = [{ key: 'Automatismes', label: '📊 Automatismes' }];
    if (niveau === '6' || niveau === '4') cats.push({ key: 'Problèmes', label: '📋 Problèmes' });
    return cats;
  }
  if (matiere === 'français' || matiere === 'Français') {
    switch (niveau) {
      case '6':
      case '4':
        return [
          { key: 'Lexique', label: '📚 Lexique' },
          { key: 'ComprehensionEcrite', label: '📖 Compréhension écrite' },
        ];
      case '5':
        return [{ key: 'CompetencesLangagieres', label: '💬 Compétences langagières' }];
      default:
        return [{ key: 'Lexique', label: '📚 Lexique' }];
    }
  }
  return [];
};

// key de catégorie → type_label backend des questions.
const TYPE_LABELS_EVAL_NAT = {
  Automatismes: 'Automatisme',
  Problèmes: 'Résolution de problèmes',
  Lexique: 'Lexique',
  CompetencesLangagieres: 'Compétences langagières et linguistiques',
  ComprehensionEcrite: "Compréhension de l'écrit",
};

// Numéro d'une clé "Q12" / "Arachné Q3" pour le tri.
const numeroQuestion = (cle) => {
  const m = (cle || '').match(/Q(\d+)/i);
  return m ? parseInt(m[1], 10) : 0;
};

/**
 * Réussite PAR ITEM d'un élève à une évaluation nationale, toutes catégories.
 *
 * Factorise la logique jusque-là interne à ResultatEvalNatByEleve : calcul des
 * catégories (matière + niveau), filtrage des questions par type_label, et les
 * 3 formes de stockage des réponses (standard / Compréhension de l'écrit éclatée
 * par document / Compétences langagières sous la clé "Compétence").
 *
 * Chaque item porte une identité STABLE (typeLabel + questionNum) partagée avec
 * ses ré-évaluations (variantes de bilan), pour préparer la vue progression.
 *
 * @param {Object} eleve   - entrée élève (eleves_reponses[i]) : { reponses, ... }
 * @param {Object} EvalNat - évaluation nationale : { matiere, classe_nom, questions }
 * @returns {Array<{ key, label, typeLabel, items: Array, compteur: Object }>}
 */
export const buildItemsEvalNatParCategorie = (eleve, EvalNat) => {
  if (!EvalNat) return [];

  const matiere = EvalNat.matiere;
  const niveau = niveauDe(EvalNat);
  const reponses = eleve?.reponses;
  const questions = Array.isArray(EvalNat.questions) ? EvalNat.questions : [];

  return categoriesEvalNat(matiere, niveau).map(({ key, label }) => {
    const typeLabel = TYPE_LABELS_EVAL_NAT[key];

    // Questions de cette catégorie (Compréhension de l'écrit = préfixe, sinon égalité)
    const questionsCategorie = questions.filter((q) =>
      key === 'ComprehensionEcrite'
        ? q.type_label?.startsWith("Compréhension de l'écrit")
        : q.type_label === typeLabel,
    );

    const items = [];
    const ajouter = (questionId, questionNum, question, reponseData) => {
      items.push({
        questionId,
        questionNum,
        categorie: key,
        typeLabel: question.type_label,
        descripteur: question.nom_label || null,
        questionLabel: question.nom_label || question.texte || 'Question',
        reponse: reponseData.réponse || reponseData.reponse || '-',
        bonneReponse: question.bonne_reponse || '-',
        score: reponseData.score,
        etat: etatDepuisScore(reponseData.score),
      });
    };

    if (reponses) {
      if (key === 'ComprehensionEcrite') {
        // Réponses éclatées par document : eleve.reponses.Arachné, .Sommeil, ... (textes : evaluationConfig)
        TEXTES_COMPREHENSION.map((t) => t.nom).forEach((doc) => {
          const reponsesDoc = reponses[doc];
          if (!reponsesDoc) return;
          Object.entries(reponsesDoc).forEach(([questionNum, reponseData]) => {
            const cle = `${doc} ${questionNum}`;
            const question = questionsCategorie.find((q) => `${nomDuTexte(q.type_label)} ${q.question_num}` === cle);
            if (question) ajouter(cle, questionNum, question, reponseData);
          });
        });
      } else {
        // Standard (clé = key) + Compétences langagières (clé "Compétence")
        const reponsesCategorie = key === 'CompetencesLangagieres' ? reponses.Compétence : reponses[key];
        if (reponsesCategorie) {
          Object.entries(reponsesCategorie).forEach(([questionNum, reponseData]) => {
            const question = questionsCategorie.find((q) => q.question_num === questionNum);
            if (question) ajouter(questionNum, questionNum, question, reponseData);
          });
        }
      }
    }

    items.sort((a, b) => numeroQuestion(a.questionId) - numeroQuestion(b.questionId));

    const compteur = items.reduce(
      (acc, it) => {
        if (it.etat === 'reussi') acc.reussis += 1;
        else if (it.etat === 'rate') acc.rates += 1;
        else acc.vides += 1;
        acc.total += 1;
        return acc;
      },
      { reussis: 0, rates: 0, vides: 0, total: 0 },
    );

    return { key, label, typeLabel, items, compteur };
  });
};


// ─── Progression par item (national → ré-évals du prof) ───────────────────────

// Taux de réussite agrégé → état de cellule (vide / réussi / partiel / raté).
export const etatDepuisRatio = (reussis, evalues) => {
  if (!evalues) return 'vide';
  if (reussis >= evalues) return 'reussi';
  if (reussis === 0) return 'rate';
  return 'partiel';
};

/**
 * Réussite PAR ITEM d'un élève à un bilan QCM de suivi, AGRÉGÉE par item.
 *
 * Symétrique de buildItemsEvalNatParCategorie mais : réponses indexées par
 * Question.id (pas question_num), et un item peut être passé plusieurs fois
 * dans le même bilan (plusieurs Question.id, même question_num) → on agrège en
 * réussis/évalués. Gère les 3 écarts de forme national↔bilan (clé Compétence,
 * préfixe Compréhension de l'écrit, indexation par id), cf. ResultatComparatifByEleve.
 *
 * @returns {Array<{ key, label, typeLabel, items: Array<{ questionId, questionNum, categorie, typeLabel, descripteur, questionLabel, reussis, evalues, etat }>, compteur }>}
 */
export const buildItemsBilanParCategorie = (eleveBilan, evalBilan) => {
  if (!evalBilan) return [];

  const matiere = evalBilan.matiere;
  const niveau = evalBilan.classe_nom?.toString()[0];
  const reponses = eleveBilan?.reponses;
  const questions = Array.isArray(evalBilan.questions) ? evalBilan.questions : [];

  return categoriesEvalNat(matiere, niveau).map(({ key, label }) => {
    const typeLabel = TYPE_LABELS_EVAL_NAT[key];

    const questionsCategorie = questions.filter((q) =>
      key === 'ComprehensionEcrite'
        ? q.type_label?.startsWith("Compréhension de l'écrit")
        : q.type_label === typeLabel,
    );

    // Agrégation par questionId (plusieurs Question.id peuvent partager un question_num).
    const parItem = new Map();
    const cumuler = (questionId, questionNum, question, reponseData) => {
      let agg = parItem.get(questionId);
      if (!agg) {
        agg = {
          questionId,
          questionNum,
          categorie: key,
          typeLabel: question.type_label,
          descripteur: question.nom_label || null,
          questionLabel: question.nom_label || question.texte || 'Question',
          reussis: 0,
          evalues: 0,
        };
        parItem.set(questionId, agg);
      }
      const s = reponseData.score;
      if (s === 1) {
        agg.reussis += 1;
        agg.evalues += 1;
      } else if (s === 0) {
        agg.evalues += 1;
      }
      // "" / null / undefined → non répondu, ignoré du ratio.
    };

    if (reponses) {
      if (key === 'ComprehensionEcrite') {
        // Réponses sous des clés "Compréhension de l'écrit <doc>" → identité composite "<doc> Qn".
        questionsCategorie.forEach((question) => {
          const cleDoc = Object.keys(reponses).find(
            (k) => k.startsWith("Compréhension de l'écrit") && reponses[k]?.[question.id] !== undefined,
          );
          if (!cleDoc) return;
          let nom = cleDoc.replace("Compréhension de l'écrit ", '');
          if (nom.startsWith('Document ')) nom = nom.replace('Document ', '');
          cumuler(`${nom} ${question.question_num}`, question.question_num, question, reponses[cleDoc][question.id]);
        });
      } else {
        // Standard + Compétences langagières (typeLabel = clé exacte côté bilan).
        const reponsesCategorie = reponses[typeLabel];
        if (reponsesCategorie) {
          questionsCategorie.forEach((question) => {
            const reponseData = reponsesCategorie[question.id];
            if (reponseData !== undefined) {
              cumuler(question.question_num, question.question_num, question, reponseData);
            }
          });
        }
      }
    }

    const items = Array.from(parItem.values()).map((agg) => ({
      ...agg,
      etat: etatDepuisRatio(agg.reussis, agg.evalues),
    }));
    items.sort((a, b) => numeroQuestion(a.questionId) - numeroQuestion(b.questionId));

    const compteur = items.reduce(
      (acc, it) => {
        acc[it.etat] = (acc[it.etat] || 0) + 1;
        acc.total += 1;
        return acc;
      },
      { reussi: 0, partiel: 0, rate: 0, vide: 0, total: 0 },
    );

    return { key, label, typeLabel, items, compteur };
  });
};

/**
 * Grille de progression d'un élève : National (point de départ) puis chaque
 * bilan QCM de suivi, aligné par item (questionId). Prêt au rendu.
 *
 * @param {Object} eleveNational - entrée élève de l'éval nationale.
 * @param {Object} evalNational  - éval nationale officielle.
 * @param {Array<{ ev, eleveEntry }>} bilans - bilans (triés par date asc) où l'élève a répondu.
 * @returns {Array<{ key, label, colonnes: Array<{ questionId, questionNum }>, lignes: Array }>}
 */
export const buildProgressionEvalNat = (eleveNational, evalNational, bilans = []) => {
  const catsNational = buildItemsEvalNatParCategorie(eleveNational, evalNational);
  if (catsNational.length === 0) return [];

  const bilansItems = bilans.map(({ ev, eleveEntry }) => ({
    ev,
    cats: buildItemsBilanParCategorie(eleveEntry, ev),
  }));

  return catsNational
    .map((catNat) => {
      // Légende des colonnes (questionId → questionNum) + cellules de la ligne National.
      const legende = new Map();
      const cellulesNational = new Map();
      let reussisNat = 0;
      let evaluesNat = 0;
      catNat.items.forEach((it) => {
        legende.set(it.questionId, it.questionNum);
        const reussis = it.score === 1 ? 1 : 0;
        const evalues = it.score === 1 || it.score === 0 ? 1 : 0;
        reussisNat += reussis;
        evaluesNat += evalues;
        cellulesNational.set(it.questionId, { reussis, evalues, etat: etatDepuisRatio(reussis, evalues) });
      });

      // Une ligne par bilan qui couvre cette catégorie.
      const lignesBilan = [];
      bilansItems.forEach(({ ev, cats }) => {
        const catBilan = cats.find((c) => c.key === catNat.key);
        if (!catBilan || catBilan.items.length === 0) return;
        const cellules = new Map();
        let reussis = 0;
        let evalues = 0;
        catBilan.items.forEach((it) => {
          legende.set(it.questionId, it.questionNum);
          cellules.set(it.questionId, { reussis: it.reussis, evalues: it.evalues, etat: it.etat });
          reussis += it.reussis;
          evalues += it.evalues;
        });
        lignesBilan.push({
          id: `bilan-${ev.id}`,
          label: ev.titre || 'Bilan',
          date: ev.date || null,
          isNational: false,
          compteur: { reussis, evalues },
          cellules,
        });
      });

      const colonnes = Array.from(legende.entries())
        .map(([questionId, questionNum]) => ({ questionId, questionNum }))
        .sort((a, b) => numeroQuestion(a.questionId) - numeroQuestion(b.questionId));

      if (colonnes.length === 0) return null;

      const ligneNational = {
        id: 'national',
        label: 'National',
        date: evalNational?.date || null,
        isNational: true,
        compteur: { reussis: reussisNat, evalues: evaluesNat },
        cellules: cellulesNational,
      };

      return { key: catNat.key, label: catNat.label, colonnes, lignes: [ligneNational, ...lignesBilan] };
    })
    .filter(Boolean);
};
